export const parseMessageAttachments = (raw) => {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      return []
    }
  }
  if (typeof raw === 'object') return [raw]
  return []
}

export const normalizeAttachment = (attachments) => {
  if (!attachments || attachments === 'null' || attachments === 'undefined') return null

  const normalized = String(attachments).trim()
  if (!normalized.length) return null

  // Cas important: payload JSON stringifié d'attachments vide.
  // Ex: "[]" ou "{}" ne doivent jamais être interprétés comme une clé S3.
  if (normalized.startsWith('[') || normalized.startsWith('{')) {
    try {
      const parsed = JSON.parse(normalized)
      if (Array.isArray(parsed)) {
        return parsed.length ? (parsed[0] || null) : null
      }
      if (parsed && typeof parsed === 'object') {
        const hasAttachmentFields = Boolean(
          String(parsed.s3Key || parsed.key || '').trim() ||
          String(parsed.s3Url || parsed.url || '').trim()
        )
        return hasAttachmentFields ? parsed : null
      }
      return null
    } catch (e) {
      return null
    }
  }

  const parsedArray = parseMessageAttachments(attachments)
  if (parsedArray.length) return parsedArray[0]

  return {
    s3Key: normalized.startsWith('http') ? '' : normalized,
    s3Url: normalized.startsWith('http') ? normalized : ''
  }
}

export const isSignedUrl = (url) => {
  const value = String(url || '').trim()
  if (!value) return false
  return value.indexOf('X-Amz-Signature=') !== -1 || value.indexOf('X-Amz-Algorithm=') !== -1
}

export const resolveAttachmentUrl = (attachments) => {
  const normalized = normalizeAttachment(attachments)
  if (!normalized) return ''

  const s3Key = String(normalized.s3Key || normalized.key || '').trim()
  const rawUrl = String(normalized.s3Url || normalized.url || '').trim()

  if (rawUrl && rawUrl.startsWith('http')) {
    if (!s3Key || isSignedUrl(rawUrl)) return rawUrl
    return ''
  }

  return ''
}

export const getAttachmentS3Key = (attachments) => {
  const normalized = normalizeAttachment(attachments)
  if (!normalized) return ''
  return String(normalized.s3Key || normalized.key || '').trim()
}

export const attachmentExtension = (attachments) => {
  const url = resolveAttachmentUrl(attachments)
  if (!url) return ''
  const cleanUrl = url.split('?')[0]
  const parts = cleanUrl.split('.')
  if (parts.length < 2) return ''
  return (parts[parts.length - 1] || '').toLowerCase()
}

export const isDocumentAttachment = (attachments) => {
  const ext = attachmentExtension(attachments)
  return ['pdf', 'doc', 'docx', 'zip'].includes(ext)
}

export const hasAttachment = (attachments) => !!resolveAttachmentUrl(attachments)

export const guessExtensionFromKey = (attachments) => {
  const key = getAttachmentS3Key(attachments)
  if (!key) return ''
  const clean = key.split('?')[0]
  const parts = clean.split('.')
  if (parts.length < 2) return ''
  return (parts[parts.length - 1] || '').toLowerCase()
}

export const defaultPresignReadEndpoint = () => {
  if (typeof window === 'undefined') return ''
  const origin = String(window.location.origin || '')
  if (origin.indexOf('localhost') > -1) return 'https://lb-sw-ai-dev-v2.watcheebox.net/api/s3/presign-read'
  if (origin.indexOf('backoffice-preprod') > -1) return 'https://lb-sw-ai-preprod-v2.watcheebox.net/api/s3/presign-read'
  if (origin.indexOf('backoffice') > -1) return 'https://lb-sw-ai-prod.watcheebox.net/api/s3/presign-read'
  return 'https://lb-sw-ai-prod.watcheebox.net/api/s3/presign-read'
}

export const fetchSignedReadUrl = async (key, endpoint = '') => {
  const safeKey = String(key || '').trim()
  const safeEndpoint = String(endpoint || '').trim()
  if (!safeKey || !safeEndpoint) return ''

  try {
    const response = await fetch(safeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: safeKey })
    })
    if (!response.ok) return ''
    const data = await response.json()
    return String((data && data.readUrl) || (data && data.url) || '').trim()
  } catch (e) {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/filters/attachment.js